'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signs = require('./signs');

var _signs2 = _interopRequireDefault(_signs);

var _nameBadges = require('./name-badges');

var _nameBadges2 = _interopRequireDefault(_nameBadges);

var _decorDecalsStickers = require('./decor-decals-stickers');

var _decorDecalsStickers2 = _interopRequireDefault(_decorDecalsStickers);

var _postersBannersRollUps = require('./posters-banners-roll-ups');

var _postersBannersRollUps2 = _interopRequireDefault(_postersBannersRollUps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  signs: _signs2.default,
  "name-badges": _nameBadges2.default,
  "decor-decals-stickers": _decorDecalsStickers2.default,
  "posters-banners-roll-ups": _postersBannersRollUps2.default

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-pricing/templates/index.js
 **/